<template>
  <div class="gid-password-reset">
    <div class="reset-password-container gid-bg-neutral">
      <p class="heading" v-if="!state">
        {{ $t('request-password-reset.title') }}
      </p>
      <p class="heading" v-if="state === 'success'">
        {{ $t('request-password-reset.success-state.title') }}
      </p>
      <p class="description" v-if="!state">
        {{ $t('request-password-reset.description') }}
      </p>
      <p class="description" v-if="state === 'success'">
        {{ $t('request-password-reset.success-state.description') }}
      </p>
      <ValidationObserver ref="observer" slim>
        <b-form class="form-wrapper" v-if="!state" @submit.prevent>
          <validating-group
            class="validating-group w-100"
            :label="$t('e-mail')"
            rules="required|email"
            :validation-context="validation_context"
            validation-path="email"
            mode="passive"
            v-slot="{ clearErrors, state }"
          >
            <b-form-input
              class="m-auto rounded-3"
              v-model="email"
              @input="email === '' && clearErrors(true)"
              type="email"
              name="email"
              rules="required|email"
              :state="state"
              :placeholder="$t('e-mail-example')"
            />
          </validating-group>

          <div v-if="error" class="api-error text-danger w-100">
            {{
              typeof error === 'string'
                ? $t(`request-password-reset.${error}`)
                : $t('request-password-reset.fail')
            }}
          </div>

          <b-col class="gid-dark-theme actions-wrapper">
            <b-button
              class="reset-btn mb-2"
              variant="primary"
              type="submit"
              @click.prevent="resetPassword"
            >
              <b-spinner v-if="loading" class="mr-2 gid-spinner--button" />
              {{ $t('request-password-reset.buttons.request') }}
            </b-button>
            <router-link to="/login" class="back-to-login">
              {{ $t('request-password-reset.buttons.back-to-login') }}
            </router-link>
          </b-col>
        </b-form>
      </ValidationObserver>

      <b-col v-if="state === 'success'" variant="success" dismissible>
        <BIconCheckCircle class="api-response-icon text-primary" />
        <p class="description mb-0 mt-3">
          <span>
            {{
              $t('request-password-reset.success-state.bact-to-login-message')
            }}
          </span>
          <router-link to="/login">
            {{ $t('request-password-reset.success-state.login-btn') }}
          </router-link>
        </p>
      </b-col>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { BIconCheckCircle } from 'bootstrap-vue';

const VALIDATION_CONTEXT = 'requestPasswordReset';

export default {
  components: {
    BIconCheckCircle,
  },
  props: {
    role: {
      type: String,
    },
  },
  data() {
    return {
      validation_context: VALIDATION_CONTEXT,
      email: null,
      error: null,
      state: null,
      loading: false,
    };
  },
  methods: {
    async resetPassword() {
      this.loading = true;

      const formIsValid = await this.$refs.observer.validate();
      if (!formIsValid) {
        this.loading = false;
        return;
      }

      try {
        const path = this.$router.resolve({ name: 'change-password' }).href;
        const absoluteUrl = new URL(path, window.location.href).href;
        const response = await axios.post('/api/auth/request-password-reset', {
          email: this.email,
          role: this.role,
          link: absoluteUrl,
        });

        if (response.data.status === 'email_not_found') {
          this.state = null;
          this.error = 'email_not_found';
        } else {
          this.state = 'success';
          this.error = null;
        }
      } catch (error) {
        this.state = null;
        this.error = true;
      }
      this.loading = false;
    },
  },
};
</script>
